import { PlatformActivityFeed } from "@lumora/ui";
import { usePlatformActivityVm } from "./platformViewModels.js";
import { PlatformPageHeader } from "./PlatformPageHeader.js";

export function PlatformActivityPage() {
  const activityVm = usePlatformActivityVm();

  return (
    <div className="site-platform">
      <PlatformPageHeader
        title="Activity"
        lead="REST audit trail for orders, checkouts, and admin actions."
      />
      <PlatformActivityFeed vm={activityVm} />
    </div>
  );
}
